import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { HiOutlineDocumentText } from "react-icons/hi";
import { CustomButton } from "../components/atoms/CustomButton";
import { LanguageChanger } from "../components/pages/dashboard/Layout";

const NotFound = () => {
  const { t, i18n } = useTranslation("clientView");

  return (
    <>
      <Helmet>
        <title>{`Super User Manager - ${t("notFound.title")}`}</title>
        <meta name="description" content={t("notFound.description") || ""} />
        <meta name="robots" content="noindex" />
        <link
          rel="canonical"
          href={`${process.env.REACT_APP_HOST_URL}/not-found`}
        />
      </Helmet>

      <div dir={i18n.dir()} className="min-h-screen bg-gray-100 flex flex-col">
        <div className="w-full h-[72px] py-4 bg-gray-700 justify-center items-center inline-flex">
          <img
            src="https://cdn.1cdn.app/application/UMD/24042216091381_Logo.svg"
            alt="Super User Manager"
            className="w-[280px]"
          />
        </div>

        <div className="flex-1 px-8 py-12 flex flex-col justify-center items-center">
          <div className="max-w-2xl w-full">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 md:p-12">
              <div className="text-center space-y-6">
                <div className="inline-flex items-center px-3 py-1 bg-blue-100 text-blue-600 text-sm font-semibold font-figtree rounded-full uppercase tracking-wide">
                  <HiOutlineDocumentText className="w-4 h-4 me-2" />
                  {t("notFound.errorCode")}
                </div>

                <div className="space-y-4">
                  {/* design-ok: hero d'affichage d'une page 404 plein ecran, taille volontaire */}
                  <h1 className="text-4xl md:text-5xl font-bold font-figtree text-gray-900 leading-tight">
                    {t("notFound.pageTitle")}
                  </h1>
                  <p className="text-gray-500 text-lg font-normal font-figtree leading-relaxed">
                    {t("notFound.description")}
                  </p>
                </div>

                <div className="pt-6 flex justify-center">
                  <a href={process.env.REACT_APP_LANDING_URL}>
                    <CustomButton
                      variant="primary"
                      title={t("notFound.websiteButton")}
                      className="px-8 py-3"
                    />
                  </a>
                </div>

                <div className="text-sm text-gray-500 font-figtree pt-8 border-t border-gray-100">
                  <p>
                    {t("notFound.helpText")}{" "}
                    <a
                      href="mailto:info@super-user-manager.com"
                      className="text-blue-600 hover:text-blue-800 underline font-medium"
                    >
                      info@super-user-manager.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center items-center gap-8 py-4 bg-gray-100">
          <LanguageChanger i18n={i18n} className="bg-gray-400" />
        </div>
        <div className="flex justify-center items-center gap-8 py-4 bg-gray-100">
          <p className="text-center text-xs text-gray-400 font-figtree">
            Made with ❤️
            <br />
            {process.env.REACT_APP_VERSION} © 2021-
            {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </>
  );
};

export default NotFound;
